// extracted by mini-css-extract-plugin
export var callCard = "_mj-0";
export var callMessageButton = "_mj-1";
export var helpIcon = "_mj-3";
export var helpIconContainer = "_mj-4";
export var verticalDivider = "_mj-2";